export default __webpack_public_path__ + "static/media/721-logo-p.7cc858ce.svg";